export function buildContactDetailPath(phone: string): `/contacts/${string}` {
  return `/contacts/${encodeURIComponent(phone)}`;
}

export function buildContactCallsPath(phone: string): `/calls?contactPhone=${string}` {
  return `/calls?contactPhone=${encodeURIComponent(phone)}`;
}

export function buildContactFollowUpsPath(phone: string): `/follow-ups?status=pending&contactPhone=${string}` {
  return `/follow-ups?status=pending&contactPhone=${encodeURIComponent(phone)}`;
}

export function buildContactCoachingPath(phone: string): `/coaching?contactPhone=${string}` {
  return `/coaching?contactPhone=${encodeURIComponent(phone)}`;
}
